import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from "@angular/core";
import { Category } from "src/app/backend/models/tag/tag";
import { buildTagsDataSource } from "src/app/support/datasources/tags.datasource";
import { TagBackend } from "src/app/backend/api/tag/tag.backend";
import { dxTagBox } from "src/app/support/dx-tag-box";
import { CreateTagFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/tag/create-tag/create-tag-function.service";

@Component({
  selector: "pms-soap-template-clinical-tags",
  templateUrl: "soap-template-clinical-tags.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class SoapTemplateClinicalTagsComponent implements OnInit {
  @Input({ required: true })
  category!: Category;

  @Input({ required: true })
  label!: string;

  @Input()
  readOnly: boolean = false;

  @Input()
  preview: boolean = false;

  @Input()
  tags: string[] = [];

  @Output()
  data: EventEmitter<{ tags: string[] }> = new EventEmitter();

  dxTagConfig!: ReturnType<typeof dxTagBox>;

  private readonly tagBackend = inject(TagBackend);
  private readonly createTagFunctionService = inject(CreateTagFunctionService);

  ngOnInit(): void {
    this.dxTagConfig = dxTagBox(
      {
        dxTagsDataSource: buildTagsDataSource(
          {
            tagsBackend: this.tagBackend
          },
          {
            disableCreateTag: false,
            category: this.category
          }
        )
      },
      {
        createTagFunctionService: this.createTagFunctionService
      },
      {
        disableRemoveButton: false
      }
    );
  }

  onTagsUpdated(tags: string[]): void {
    this.data.emit({
      tags: tags
    });
    this.tags = tags;
  }
}
